module.exports = __webpack_public_path__ + "assets/ab8d0f97dd54a09d61d41b0d72795447.png";